var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6836 2.7959V4.12891H13.3379C13.3402 4.12891 13.3412 4.12965 13.3418 4.12988C13.3428 4.1303 13.345 4.13117 13.3467 4.13281C13.3481 4.13434 13.3492 4.1358 13.3496 4.13672V14.8164L13.3467 14.8252C13.3443 14.8276 13.3403 14.8291 13.3369 14.8291H2.66211L2.65332 14.8252C2.65117 14.823 2.65039 14.8195 2.65039 14.8164V4.13672C2.65078 4.1358 2.65188 4.13434 2.65332 4.13281C2.65497 4.13117 2.65722 4.1303 2.6582 4.12988C2.65879 4.12965 2.65975 4.12891 2.66211 4.12891H5.31641V2.7959H10.6836ZM2.68359 14.7959H13.3164V4.16211H10.6836V5.49512H5.31641V4.16211H2.68359V14.7959ZM5.34961 12.1289V12.1621H5.31641V12.1289H5.34961ZM5.34961 10.1289V10.1621H5.31641V10.1289H5.34961ZM5.34961 8.12891V8.16211H5.31641V8.12891H5.34961ZM5.34961 5.46191H10.6504V2.8291H5.34961V5.46191Z",
    stroke: "inherit",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.ab77854adbcfda43510a2aa625056d14.svg";
export { ForwardRef as ReactComponent };